import {
  faBiking,
  faCamera,
  faCampground,
  faFolderOpen,
  faInfo,
  faStarHalfAlt,
  faStore,
  faThumbsUp,
  faUtensils,
  faWifi,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import React, { useState } from 'react';

// eslint-disable-next-line no-sparse-arrays
const allTopics = [
  {
    label: 'All Topics',
    tag: undefined,
    icon: (
      <FontAwesomeIcon
        style={{
          width: '22px',
          height: '22px',
          marginBottom: '5px',
        }}
        icon={faFolderOpen}
      />
    ),
  },
  {
    label: 'Advice',
    tag: 'traveladvice',
    icon: (
      <FontAwesomeIcon
        style={{
          width: '22px',
          height: '22px',
          marginBottom: '5px',
        }}
        icon={faInfo}
      />
    ),
  },
  {
    label: 'Photography',
    tag: 'photography',
    icon: (
      <FontAwesomeIcon
        style={{
          width: '22px',
          height: '22px',
          marginBottom: '5px',
        }}
        icon={faCamera}
      />
    ),
  },
  {
    label: 'Food',
    tag: 'foodoftheworld',
    icon: (
      <FontAwesomeIcon
        style={{
          width: '22px',
          height: '22px',
          marginBottom: '5px',
        }}
        icon={faUtensils}
      />
    ),
  },
  {
    label: 'Markets',
    tag: 'marketfriday',
    icon: (
      <FontAwesomeIcon
        style={{
          width: '22px',
          height: '22px',
          marginBottom: '5px',
        }}
        icon={faStore}
      />
    ),
  },
  {
    label: 'Digital Nomads',
    tag: 'digitalnomads',
    icon: (
      <FontAwesomeIcon
        style={{
          width: '22px',
          height: '22px',
          marginBottom: '5px',
        }}
        icon={faWifi}
      />
    ),
  },
  {
    label: 'Review',
    tag: 'review',
    icon: (
      <FontAwesomeIcon
        style={{
          width: '22px',
          height: '22px',
          marginBottom: '5px',
        }}
        icon={faStarHalfAlt}
      />
    ),
  },
  {
    label: 'Cycling',
    tag: 'cyclefeed',
    icon: (
      <FontAwesomeIcon
        style={{
          width: '22px',
          height: '22px',
          marginBottom: '5px',
        }}
        icon={faBiking}
      />
    ),
  },
  ,
  {
    label: 'Hitchhiking',
    tag: 'hitchhiking',
    icon: (
      <FontAwesomeIcon
        style={{
          width: '22px',
          height: '22px',
          marginBottom: '5px',
        }}
        icon={faThumbsUp}
      />
    ),
  },
  ,
  {
    label: 'Outdoor',
    tag: 'outdoor',
    icon: (
      <FontAwesomeIcon
        style={{
          width: '22px',
          height: '22px',
          marginBottom: '5px',
        }}
        icon={faCampground}
      />
    ),
  },
];

const TopicSelector = props => {
  const [value, setValue] = useState(0);

  let topics = [];
  try {
    topics = JSON.parse(props.topics);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
  let selectedTopics = [];
  if (topics.length > 0) selectedTopics = [allTopics[0]];

  allTopics.forEach(topic => {
    if (topics.indexOf(topic.tag) !== -1) selectedTopics.push(topic);
  });

  return (
    <>
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
          props.onChange(selectedTopics[newValue].tag);
        }}
        showLabels
      >
        {selectedTopics.map(topic => {
          return (
            <BottomNavigationAction
              key={topic.label}
              label={topic.label}
              icon={topic.icon}
            />
          );
        })}
      </BottomNavigation>
    </>
  );
};

export default TopicSelector;
